var render = function render(){var _vm=this,_c=_vm._self._c;return _c('wallet',{attrs:{"load":_vm.entity.hasOwnProperty('status'),"status":_vm.entity.status,"with-label":_vm.withLabel,"dark":_vm.dark,"amount":_vm.entity.wallet,"blocked_amount":_vm.entity.blocked_amount,"center":_vm.center,"access":_vm.access}})
}
var staticRenderFns = []

export { render, staticRenderFns }